import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable({ providedIn: 'root' })
export class MultilangAnalytics extends AnalyticsBase {
  public readonly namespace: string = 'Multilanguage';
  public readonly requireViewContext: boolean = false;

  public trackManageJobLanguages(): void {
    this.track('ManageJobLanguages');
  }
}
